import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      successStoriesBanner: {
        livejasmin: {
          ...defineMessages({
            successStories: {
              id: 'pages.landing.successStoriesBanner.livejasmin.successStories',
              defaultMessage: 'Success stories from <b>our Models</b>',
            },
            fromHuge: {
              id: 'pages.landing.successStoriesBanner.livejasmin.fromHuge',
              defaultMessage:
                'From huge earnings to unique experiences and exotic celebrations, discover in their own words, why models love LiveJasmin.',
            },
            joinNow: {
              id: 'pages.landing.successStoriesBanner.livejasmin.joinNow',
              defaultMessage: 'Join Now',
            },
            watchInterview: {
              id: 'pages.landing.successStoriesBanner.livejasmin.watchInterview',
              defaultMessage: 'Watch Interview',
            },
          }),
          quotes: {
            ...defineMessages({
              vicky: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.vicky',
                defaultMessage:
                  '“I have a community that really helps me, empowers me and helps me grow. It’s not just bare skin...”',
              },
              rebecca: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.rebecca',
                defaultMessage:
                  '“I don’t like to call it a job... This is more like an activity that pays you off at the end of the day.”',
              },
              charlotteMavis: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.charlotteMavis',
                defaultMessage:
                  '“I am living my dream, I love Jasmin for open up the doors for me so I can  just go in and work my way”',
              },
              amandaRuth: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.amandaRuth',
                defaultMessage:
                  '“I can do absolutely anything I want, I can travel, I can buy what I want, I can achieve absolutely all the dreams and ideals...”',
              },
              lanaRhodes: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.lanaRhodes',
                defaultMessage:
                  "“My life changed because now I can trust myself more than I used to do. I'm more confident”",
              },
              christineDavis: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.christineDavis',
                defaultMessage:
                  '“I’ve been able to travel a lot: Maldives, Bali, Seychelles, Spain, Italy. I’ve achieved so much in just three years.”',
              },
              evaTalks: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.evaTalks',
                defaultMessage:
                  '“The platform gives you possibilities and opportunities, a variety of choices, and you can choose how to use them.”',
              },
              nicoleBella: {
                id: 'pages.landing.successStoriesBanner.livejasmin.quotes.nicoleBella',
                defaultMessage:
                  '“I feel like home here... Jasmin gives me freedom. I can do whatever I want, whenever I want.”',
              },
            }),
          },
        },
      },
    },
  },
};
